import React from 'react';

import FundProfileShowPageContainer from 'buyside/components/container/FundProfileShow/FundProfileShowPageContainer';
import Heading from 'buyside/components/presentation/ContributorDashboard/contributorDashboardHeading';
import LoadingSpinner, {
  SIZES
} from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';
import Tabs, { TabContent, TabNav } from 'buyside/components/presentation/Tabs/tabsComponents';

import { useCurrentUserFundProfileQuery } from 'interfaces/graphql-typings';

import styles from 'buyside/components/presentation/ContributorDashboard/contributorDashboardStyles.scss';

export const fundProfileHeading = 'Fund Profile';

const MyFundProfiles: React.FC = () => {
  const { error, data, loading } = useCurrentUserFundProfileQuery();

  if (loading)
    return (
      <>
        <Heading title={fundProfileHeading} />
        <LoadingSpinner size={SIZES.LARGE} />
      </>
    );
  if (error) throw error;
  if (!data || !data.currentUser) return null;

  const adminFundProfiles = data.currentUser.adminFundProfiles;

  return (
    <>
      <Heading title={fundProfileHeading} />
      {adminFundProfiles.length ? (
        adminFundProfiles.length === 1 ? (
          <FundProfileShowPageContainer employerProfileId={adminFundProfiles[0].id} shrink />
        ) : (
          <Tabs>
            <TabNav className={styles.tabNav}>
              {adminFundProfiles.map(({ name }) => (
                <span key={`${name}-tab`}>{name}</span>
              ))}
            </TabNav>
            <TabContent unmountOnChange>
              {adminFundProfiles.map(({ id }) => (
                <FundProfileShowPageContainer
                  key={`fund-profile-${id}`}
                  employerProfileId={id}
                  shrink
                />
              ))}
            </TabContent>
          </Tabs>
        )
      ) : (
        <div className={styles.noContentMsg}>
          You do not have a profile yet. Please contact{' '}
          <a href="mailto:capintro@sumzero.com">
            <strong>capintro@sumzero.com</strong>
          </a>{' '}
          to get started.
        </div>
      )}
    </>
  );
};

export default MyFundProfiles;
